import { render, staticRenderFns } from "./About.vue?vue&type=template&id=d4b24088&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=d4b24088&scoped=true&lang=css&"
import style1 from "./About.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b24088",
  null
  
)

export default component.exports